import { Box, styled } from "@mui/material";
import { BasicTableRowStyles } from "../../../components/common/Common.styles";

export const TableHeaderStyles = styled(Box)(({ theme }) => ({
  display: "contents",
  gridTemplateColumns: "20% 30% 20% 15% 15%",
  background: theme.palette.background.default,
  color: theme.palette.text.primary,
  fontWeight: 600,
  fontSize: "1rem",
  borderBottom: `2px solid ${theme.palette.border.main}`,
  position: "sticky",
  top: 0,
  zIndex: 1,
  "& > div": {
    height: "60px",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

export const TransactionsRowStyles = styled(BasicTableRowStyles)(({ theme }) => ({
  "&:last-child": {
    border: "none",
  },
  display: "contents",
  "& > div": {
    height: "79px",
    padding: "0 12px",
    display: "flex",
    alignItems: "center",
  },
}));
